const HUBSPOT_FORMS_SCRIPT_SRC = '//js.hsforms.net/forms/embed/v2.js'
const HUBSPOT_FORMS_SCRIPT_ID = 'hs-forms-embed-v2'

declare global {
  interface Window {
    hbspt?: {
      forms: {
        create: (options: {
          region: string
          portalId: string
          formId: string
          target: string
        }) => void
      }
    }
  }
}

let loadingPromise: Promise<void> | null = null

const loadHubSpotFormsScript = (): Promise<void> => {
  if (typeof window === 'undefined') {
    return Promise.resolve()
  }

  if (window.hbspt?.forms?.create) {
    return Promise.resolve()
  }

  if (loadingPromise) {
    return loadingPromise
  }

  loadingPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById(HUBSPOT_FORMS_SCRIPT_ID) as HTMLScriptElement | null
    if (existing) {
      existing.addEventListener('load', () => resolve())
      existing.addEventListener('error', () => reject(new Error('Failed to load HubSpot forms script')))
      return
    }

    const script = document.createElement('script')
    script.id = HUBSPOT_FORMS_SCRIPT_ID
    script.src = HUBSPOT_FORMS_SCRIPT_SRC
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => {
      loadingPromise = null
      reject(new Error('Failed to load HubSpot forms script'))
    }
    document.body.appendChild(script)
  })

  return loadingPromise
}

export default loadHubSpotFormsScript
